import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { initAnalytics } from '@lib/analytics';

// Inicializa GA4 (ANL-01) — no-op se VITE_GA4_MEASUREMENT_ID nao esta setado
// (dev, preview sem env var). Carregamento do gtag.js e async (ANL-03), nao
// bloqueia o first paint.
initAnalytics();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');
createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
